import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { getRCSDashboard } from "../api/RCSDashboardApi";

export const useRCSDashboardSummary = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["RCSCardsSummary"],
    queryFn: async () => {
      return await getRCSDashboard({ token: user.token });
    },
    initialData: {},
    refetchOnWindowFocus: false,
  });
};
